export class LoginPage {
    modal: JQuery<HTMLElement>;
    acceptCheckbox: JQuery<HTMLElement>;
    modalSubmitBtn: JQuery<HTMLElement>;

    loginBtn: JQuery<HTMLElement>;
    loginSpinner: JQuery<HTMLElement>;
    loginForm: HTMLFormElement;

    modalSpinner: JQuery<HTMLElement>;

    constructor() {
        this.modal = $("#attestation-modal");
        this.acceptCheckbox = this.modal.find("input[name='acceptCheckbox']");
        this.modalSubmitBtn = this.modal.find("button[type='submit']");
        this.modalSpinner = this.modal.find("#submit-attestation-spinner");

        this.loginForm = <HTMLFormElement>document.getElementById("account");

        this.initModal();
    }

    private initModal(): void {
        if (this.modal.hasClass("force-show")) {
            this.modal.modal("show");
        }

        if (this.acceptCheckbox) {
            this.acceptCheckbox.on("change", () => {
                this.toggleSubmitButton();
            });
        }

        let attestationForm = $("#attestation-form"); 
        attestationForm.on("submit", async (e) => {
            e.preventDefault();
            let redirectUrl = await this.submitAttestation();
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
            else {
                window.location.reload();
            }
        })
    }

    private toggleSubmitButton(): void {
        if (this.acceptCheckbox && this.modalSubmitBtn) {
            let isChecked = this.acceptCheckbox.is(":checked");
            this.modalSubmitBtn.prop("disabled", !isChecked);
        }
    }

    async submitAttestation(): Promise<any> {
        // Show Loading
        this.modalSpinner.removeClass("d-none");
        this.modalSubmitBtn.addClass("d-none");

        let formElement = <HTMLFormElement>document.getElementById("account");
        let formData = new FormData(formElement);

        let result = await $.ajax("/auth/pages/login/login?handler=AcceptAttestation", {
            method: "POST",
            headers: { "RequestVerificationToken": <string>$('input[name="__RequestAttestationToken"]').val() },
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            error: () => {
                window.location.reload();
            }
        });

        return result;
    }

}